export const COUNTRIES = {
  MEXICO: 'MEXICO',
};
